import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, ArrowLeft, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

/** تنقّل موحّد بين مراحل المشروع: زرّان فقط — اعتماد (يصبح «معتمدة») ثم «التالي: المرحلة التالية». */
export const StageNav = ({ approved, saving, onApprove, approveLabel, approvedLabel, nextLabel, nextTo, approveSlot, testId = "stage" }) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-end gap-3" data-testid={`${testId}-nav`}>
      {approveSlot || (approved ? (
        <Button disabled className="bg-emerald-600 text-white gap-2 opacity-100" data-testid={`${testId}-approved`}>
          <ShieldCheck className="w-4 h-4" /> {approvedLabel}
        </Button>
      ) : (
        <Button onClick={onApprove} disabled={saving} className="bg-primary hover:bg-primary/90 text-white gap-2 font-bold" data-testid={`${testId}-approve-btn`}>
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <ShieldCheck className="w-4 h-4" />} {approveLabel}
        </Button>
      ))}
      <Button onClick={() => navigate(nextTo)} disabled={!approved} variant="outline"
        className="border-accent/50 text-accent gap-2 font-bold disabled:opacity-50" title={approved ? "" : "اعتمد المرحلة أولاً"} data-testid={`${testId}-next-btn`}>
        {nextLabel} <ArrowLeft className="w-4 h-4" />
      </Button>
    </div>
  );
};
